import { services } from "../../../../constants";

export default async function userEligibility(data) {
    const url = `${this.backendHosts.auth}${services.userEligibility}`;
    try {
        const response = await this.http.post(url, data, await this.getHeaders());
        return response;
    } catch (error) {
      this.handleErrorResponse(error);
    }
  }